import React from 'react';
import PageMapper from '../helpers/pageMapper';
import Hero from '../atoms/Hero';
import { jsonReader } from '../helpers/tools';

class Welcome extends React.Component {
    constructor() {
        super();
        this.state = { data: [] };
    }

    async componentDidMount() {
        const result = await jsonReader('page_welcome.json');
        this.setState({ data: result || [] });
    }

    render() {
        return (
            <div style={{ flex: 1, minWidth: 0 }}>
                <Hero />
                <PageMapper data={this.state.data} />
            </div>
        );
    }
}

export default Welcome;
